const normalize = value => String(value || '').toLocaleLowerCase('ru').replace(/ё/g, 'е');
const compareText = (a, b) => normalize(a).localeCompare(normalize(b), 'ru', {numeric: true});
const unavailableLabel = 'Разбивка по объектам не сохранена';
const status = value => ({paid: 'Выплачено', returned: 'На доработке', on_hold: 'Выплата отложена', payable: 'К выплате', pending: 'Ожидает приёмки'}[value] || 'Ожидает');
function correctionNotice(summary) {
    const state = summary.accounting || {};
    if (!state.partial) return '';
    const label = count => count + ' ' + (count % 10 === 1 && count % 100 !== 11 ? 'сотрудник' : count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 12 || count % 100 > 14) ? 'сотрудника' : 'сотрудников');
    return [state.returned_count ? 'На доработке: ' + label(state.returned_count) : '',
        state.awaiting_count ? 'Исправления ожидают приёмки: ' + label(state.awaiting_count) : ''].filter(Boolean).join('. ') + '. Выплата этих начислений заблокирована до приёмки.';
}
function rowNotice(line) {
    if (line.correction) return line.correction.state === 'awaiting' ? 'Исправлено — ожидает приёмки'
        : line.correction.initiator === 'manager' ? 'Руководитель забрал на доработку — выплата недоступна' : 'На доработке — выплата недоступна';
    return line.previous_amount ? 'На доработке · ранее переданная сумма' : line.payment_status === 'pending' ? 'Ожидает приёмки' : '';
}
const compareRow = sort => (a, b) => {
    const descending = sort.endsWith('-desc') ? -1 : 1;
    const value = sort.startsWith('amount-') ? a.final_amount_minor - b.final_amount_minor
        : compareText(a.employee_name_snapshot, b.employee_name_snapshot);
    return descending * value || compareText(a.employee_name_snapshot, b.employee_name_snapshot)
        || compareText(a.currency, b.currency) || Number(a.id) - Number(b.id);
};
function visible(lines, query, sort = 'name-asc') {
    return lines.filter(line => normalize(line.employee_name_snapshot).includes(normalize(query).trim())).slice().sort(compareRow(sort));
}
function objects(line) {
    return (line.objects || []).slice().sort((a, b) => compareText(a.object_name, b.object_name) || a.building_id - b.building_id);
}
function contractLabel(object) {
    const date = /^\d{4}-\d{2}-\d{2}$/.test(object.contract_date || '') ? object.contract_date.split('-').reverse().join('.') : '';
    return object.contract_number || date ? `Договор${object.contract_number ? ` №${object.contract_number}` : ''}${date ? ` от ${date}` : ''}` : 'Договор: —';
}
function totals(lines) {
    const result = new Map();
    lines.forEach(line => {
        const total = result.get(line.currency) || {currency: line.currency, amount: 0, available: 0, returned: 0, awaiting: 0, held: 0, actual: 0, difference: 0, paidCount: 0, unknown: 0};
        total.amount += line.final_amount_minor;
        const bucket = {payable: 'available', returned: 'returned', pending: 'awaiting', on_hold: 'held'}[line.payment_status];
        if (bucket) total[bucket] += line.final_amount_minor;
        if (line.payment_status === 'paid') {
            if (line.actual_amount_minor == null) total.unknown++;
            else {total.paidCount++; total.actual += line.actual_amount_minor; total.difference += line.payment_difference_minor || 0;}
        }
        result.set(line.currency, total);
    });
    return Array.from(result.values()).sort((a, b) => compareText(a.currency, b.currency));
}
function groups(lines, sort = 'name-asc', direction = 'asc') {
    const result = new Map(), unknown = [];
    lines.forEach(line => {
        if (!line.object_breakdown_available || !(line.objects || []).length) { unknown.push(line); return; }
        objects(line).forEach(object => {
            const key = String(object.building_id), group = result.get(key) || {key, name: object.object_name,
                contract_number: object.contract_number, contract_date: object.contract_date, unavailable: false, lines: []};
            // Only the approved amount per object belongs here, never the monthly payment fact.
            group.lines.push({id: line.id, employee_name_snapshot: line.employee_name_snapshot,
                currency: line.currency, final_amount_minor: object.final_amount_minor, payment_status: line.payment_status, previous_amount: line.previous_amount, correction: line.correction});
            result.set(key, group);
        });
    });
    const ordered = Array.from(result.values()).sort((a, b) => (direction === 'desc' ? -1 : 1) * compareText(a.name, b.name) || Number(a.key) - Number(b.key));
    if (unknown.length) ordered.push({key: 'unallocated', name: unavailableLabel, unavailable: true, lines: unknown});
    return ordered.map(group => ({...group, lines: group.lines.slice().sort(compareRow(sort)), totals: totals(group.lines)}));
}
const corrections = summary => (summary.runs || []).flatMap(run => run.lines.filter(line => line.correction || line.previous_amount)
    .map(line => ({...line, currency: run.currency})));
module.exports = {correctionNotice, rowNotice, corrections, visible, objects, contractLabel, totals, groups, status, unavailableLabel};
